import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";

//import "./../../Public/css/style.css";
//import './../../../Public/css/style.css';

import {getCallersAPI, getCallerByCampaignAPI, getDispositionAPI, getSubdispositionAPI, getCampaignsAPI, getStagesAPI, LeadsAPI} from "./../../../API/Team/ReportAPI";
//import Sidebar from "./../Common/Sidebar";
//import Header from "./../Common/Header";
//import InvitationModal from "./InvitationModal";
//import Loader from "./../../Loader";
//import Chart from 'react-apexcharts';
//import PieChart from './../../../utils/Charts/PieChart';
//import FunnelChart from './../../../utils/Charts/FunnelChart';
import Paginate from "../../../utils/Pagination";
//import DeleteConfirmPopup from "./../../utils/DeleteConfirmPopup";
import Layout from "./../../Layout";
import ContentLoader from "../../../utils/ContentLoader";

const Report = () =>{

    const[callers, setCallers] = useState([]);
    const[datefilteroption, setDateFilterOption] = useState(null);
    const[startdate, setStartDate] = useState("");
    const[enddate, setEndDate] = useState("");
    const[selectcaller, setSelectCaller] = useState("");
    const[showcustomdates, setShowCustomDates] = useState(false);
    const[btnapplyloader, setBtnApplyLoader] = useState(false);
    const[btnclearloader, setBtnClearLoader] = useState(false);
    const[dataloader, setDataLoader] = useState(false);
    /*const[callersummary, setCallerSummary] = useState([]);
    const[leadstatus, setLeadStatus] = useState([]);
    const[leadstatusdata, setLeadStatusData] = useState(null);
    const[leadstatusoptions, setLeadStatusOptions] = useState([]);
    const[leadstatusseries, setLeadStatusSeries] = useState([]);
    const[showleadstatuschart, setShowLeadStatusChart] = useState(true);
    const[showleadfunnelreport, setShowLeadFunnelReport] = useState(true);*/
    //const[showcallerstats, setShowCallerStats] = useState(false);
    //const[callerstats, setCallerStats] = useState({});
    const[campaigns, setCampaigns] = useState([]);
    const[stages, setStages] = useState([]);
    const[dispositions, setDispositions] = useState([]);
    const[subdispositions, setSubDispositions] = useState([]);
    const[selectcampaign, setSelectCampaign] = useState("");
    const[selectstage, setSelectStage] = useState("");
    const[selectdisposition, setSelectDisposition] = useState("");
    const[selectsubdisposition, setSelectSubDisposition] = useState("");
    const[leads, setLeads] = useState([]);
    const[leadcount, setLeadCount] = useState(0);
    const[payamount, setPayAmount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [filtersStored, setFiltersStored] = useState(null);
    const [filtersDraft, setFiltersDraft] = useState({ 
                                                    filter_campaign: "",
                                                    filter_caller: "",
                                                    filter_stage: "",
                                                    filter_dispositionid: "",
                                                    filter_subdispositionid: "",
                                                    filter_datetype: "",
                                                    filter_startdate: "",
                                                    filter_enddate: ""
                                                });

    const perpagedata = 20;

    useEffect(()=>{

        getCampaignsAPI(setCampaigns);
        getCallersAPI(setCallers);
        getStagesAPI(setStages);
        //CallerAPI(setCallers);
        //CallerSummaryAPI(setCallerSummary);
        //LeadStatusAPI(setLeadStatus, setLeadStatusOptions,setLeadStatusSeries, setShowLeadStatusChart, setShowLeadFunnelReport, null);

        

        //fetchReports();

    }, []);

    useEffect(() =>{

        if (!filtersStored) return;

        const params = new URLSearchParams();

        Object.keys(filtersStored).forEach(key => {
            if (filtersStored[key]) {
                params.append(key, filtersStored[key]);
            }
        });

        params.append("page", currentPage);
        params.append("per_page", perpagedata);

        LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, params);

    }, [filtersStored, currentPage])

    

    const handleDateFilterOption = (e) =>{

        console.log(e.target.value);

        if(e.target.value === 'customdate')
        {
            setShowCustomDates(true);
        }
        else
        {
            setShowCustomDates(false);
        }

        setDateFilterOption(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filter_datetype: e.target.value
                        }));

    }

    const handleStartDate = (e) =>{
        setStartDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filter_startdate: e.target.value
                        }));
    }

    const handleEndDate = (e) =>{
        setEndDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filter_enddate: e.target.value
                        }));
    }

    const handleSelectCampaign = (e) =>{

        setSelectCampaign(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filter_campaign: e.target.value
                        }));

        getCallerByCampaignAPI(e.target.value, setCallers);
    }

    const handleSelectCaller = (e) =>{
        setSelectCaller(e.target.value); 
        
        setFiltersDraft(prev => ({
                            ...prev,
                            filter_caller: e.target.value
                        }));
    }

    const handleSelectStage = (e) =>{
        setSelectStage(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filter_stage: e.target.value
                        }));

        getDispositionAPI(e.target.value, setDispositions);
    }

    const handleSelectDisposition = (e) =>{
        setSelectDisposition(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filter_dispositionid: e.target.value
                        }));

        getSubdispositionAPI(e.target.value, setSubDispositions);
    }

    const handleSelectSubDisposition = (e) =>{
        setSelectSubDisposition(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filter_subdispositionid: e.target.value
                        }));
    }

    const handleApplyFilter = (e) =>{        

        setFiltersStored({
                            ...filtersDraft,
                            page: 1
                        });

        setCurrentPage(1);

        //LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, filterparams);
    }

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleResetFilter = (e) =>{
        setSelectCaller("");
        //setShowCallerStats(false);
        setSelectCampaign("");
        setSelectCaller("");
        setSelectStage("");
        setSelectDisposition("");
        setSelectSubDisposition("");

        setFiltersDraft({
                    filter_campaign: "",
                    filter_caller: "",
                    filter_stage: "",
                    filter_dispositionid: "",
                    filter_subdispositionid: "",
                    filter_datetype: "",
                    filter_startdate: "",
                    filter_enddate: ""
        });

        setFiltersStored(null);
        setCurrentPage(1);
        
        LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, null);
    }

    console.log('Lead count=====' + leads.data);

    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Report</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card crm-leads-filter-card">
                        <div className="card-body">
                            <div className="row crm-filter-row-top">
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Campaign</label>
                                    <select className="form-select" name="campaign" value={selectcampaign} onChange={handleSelectCampaign}>
                                        <option value="">Select Campaign</option>
                                        {campaigns.map((campaign) =>
                                            (
                                                <option key={campaign.id} value={campaign.id}>{campaign.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Caller</label>
                                    <select className="form-select" name="caller" value={selectcaller} onChange={handleSelectCaller}>
                                        <option value="">Select Caller</option>
                                        {callers.map((caller) =>
                                            (
                                                <option key={caller.id} value={caller.id}>{caller.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Stage</label>
                                    <select className="form-select" name="stage" value={selectstage} onChange={handleSelectStage}>
                                        <option value="">Select Stage</option>
                                        {stages.map((stage) =>
                                            (
                                                <option key={stage.id} value={stage.id}>{stage.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label class="crm-filter-label">Disposition</label>
                                    <select className="form-select" name="disposition" value={selectdisposition} onChange={handleSelectDisposition}>
                                        <option value="">Select Disposition</option>
                                        {dispositions.map((disposition) =>
                                            (
                                                <option key={disposition.id} value={disposition.id}>{disposition.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label class="crm-filter-label">Sub-Disposition</label>
                                    <select className="form-select" name="subdisposition" value={selectsubdisposition} onChange={handleSelectSubDisposition}>
                                        <option value="">Select SubDisposition</option>
                                        {subdispositions.map((subdisposition) =>
                                            (
                                                <option key={subdisposition.id} value={subdisposition.id}>{subdisposition.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                            </div>

                            <div class="row crm-filter-row-bottom align-items-end">
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Date Filter</label>
                                    <select className="form-select" name="date-filter" onChange={handleDateFilterOption}>
                                        <option value="">Select Date</option>
                                        <option value="today">Today</option>
                                        <option value="yesterday">Yesterday</option>
                                        <option value="last7days">Last 7 Days</option>
                                        <option value="last30days">Last 30 Days</option>
                                        <option value="thismonth">This Month</option>
                                        <option value="lastmonth">Last Month</option>
                                        <option value="customdate">Custom Date</option>
                                    </select>
                                </div>

                                <div className={ showcustomdates ? 'col-md-2 mb-3 custom-date-filter dropdown' : 'col-md-2 mb-3 custom-date-filter dropdown d-none'}>
                                    <label class="crm-filter-label">Start Date</label>
                                    <input className="form-control" type="date" name="startdate" placeholder="Start Date" onChange={handleStartDate} />
                                    {/*<span className="me-2 mx-2 mt-2"><h6>To</h6></span>
                                    <input className="form-control" type="date" name="enddate" onChange={handleEndDate} />*/}
                                </div>
                                <div className={ showcustomdates ? 'col-md-2 mb-3 custom-date-filter dropdown' : 'col-md-2 mb-3 custom-date-filter dropdown d-none'}>
                                    <label class="crm-filter-label">End Date</label>
                                    {/*<input className="form-control" type="date" name="startdate" onChange={handleStartDate} />
                                    <span className="me-2 mx-2 mt-2"><h6>To</h6></span>*/}
                                    <input className="form-control" type="date" name="enddate" placeholder="End Date" onChange={handleEndDate} />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label class="crm-filter-label opacity-0">Actions</label>
                                    <div class="crm-filter-actions">
                                        <button type="button" className="btn btn-primary" onClick={handleApplyFilter}>
                                                <i className="ti ti-search me-2"></i>Apply Filter
                                        </button>

                                        <button type="button" className="btn btn-dark" onClick={handleResetFilter}>
                                            <i className="fa fa-undo me-2"></i>Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card fresh">
                                <div className="card-body p-3 d-flex align-items-center mx-auto">
                                    <div>
                                        <div className="fs-25 fw-semibold widget-text text-center">{leadcount}</div>
                                        <div className="text-body-secondary fw-semibold widget-heading">Leads</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card follow">
                                <div className="card-body p-3 d-flex align-items-center mx-auto">
                                    <div>
                                        <div className="fs-25 fw-semibold widget-text text-center">{payamount}</div>
                                        <div className="text-body-secondary fw-semibold widget-heading">Paid Reg. Fee</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive table-wrapper">
                                {dataloader ?

                                    <ContentLoader />
                                :
                                <table className="table table-data-section" id="faqlist">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Contact</th>
                                            <th>Location</th>
                                            <th>Program</th>
                                            <th>Institute</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                    leads && leads.length > 0 ?
                                        leads.map(lead =>
                                            <tr key={lead.id}>
                                                <td>{lead.name}</td>
                                                <td>{lead.email}</td>
                                                <td>{lead.contact}</td>
                                                <td>{lead.location}</td>
                                                <td>{lead.program}</td>
                                                <td>{lead.institute}</td>
                                                <td>
                                                    <span class="badge badge-tag badge-purple-light">{lead.stagename}</span>
                                                </td>
                                            </tr>
                                        )
                                    :
                                        <tr>
                                            <td colSpan="7">No data found...</td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }

                            </div>
                        </div>
                    </div>
                </div>

                {pagecount > 1 &&
                <div className="pagination-section mt-3">

                    <nav>
                        <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                    </nav>
                </div>
                }
            </div>

        </div>
    </Layout>
    );
}

export default Report;
